let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gdjJS")).then(() => parcelRequire('cvdsU'));